import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';
import {
  DISCOVERY_TAG_TYPE,
  DISCOVERY_LIST_ID,
  DISCOVERY_MAP_ID,
} from './constants';
import type {
  DiscoveryListRequest,
  DiscoveryMapRequest,
  DiscoveryListResponse,
  DiscoveryMapResponse,
} from './types';

export const discoveryApi = createApi({
  reducerPath: 'discoveryApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [DISCOVERY_TAG_TYPE],
  endpoints: (builder) => ({
    getDiscoveryList: builder.query<DiscoveryListResponse, DiscoveryListRequest>({
      query: ({ params, data }) => {
        const queryParams = getSearchQueryParamsForAPI(params);
        return {
          url: `v1/search/discovery/list/${queryParams}`,
          method: 'POST',
          body: data,
        };
      },
      providesTags: [{ type: DISCOVERY_TAG_TYPE, id: DISCOVERY_LIST_ID }],
    }),

    getDiscoveryMap: builder.query<DiscoveryMapResponse, DiscoveryMapRequest>({
      query: ({ params, data }) => {
        const queryParams = getSearchQueryParamsForAPI(params);
        return {
          url: `v1/search/discovery/map/${queryParams}`,
          method: 'POST',
          body: data,
        };
      },
      providesTags: [{ type: DISCOVERY_TAG_TYPE, id: DISCOVERY_MAP_ID }],
    }),
  }),
});

export const {
  useGetDiscoveryListQuery,
  useGetDiscoveryMapQuery,
} = discoveryApi;
